module.exports = __webpack_public_path__ + "assets/smart-asset-website-active.037f2fcc.svg";